module.exports = __webpack_public_path__ + "img/4-1-3-2-preview-staycationdelights-c.ac72ef6d.jpg";